import styled from 'styled-components';
import { vars } from '@snsw-gel/theming';

export const AGENCY_LOGO_HEIGHT = 76;

export const auxId = 'header_global_auxiliary';
export const navId = 'header_global';
export const headerIdAttribute = 'data-ga4-section-id';

export const GlobalNavStyles = styled.div<{ customNav: boolean }>`
  ${(props) =>
    props.customNav &&
    `
    /* color the navbar */
    div[${headerIdAttribute}='${auxId}'] {
      display: block !important;
      background-color: ${vars.colors.primary} !important;
    }

    /* action buttons - change language, logout, etc */
    div[${headerIdAttribute}='${auxId}'] button,
    div[${headerIdAttribute}='${auxId}'] [class*='Translate'],
    div[${headerIdAttribute}='${auxId}'] [class*='MenuButton'] {
      background-color: ${vars.colors.primary} !important;
      color: ${vars.colors.primary.text} !important;
    }

    /* fill the chevron up svg on clicking change language */
    div[${headerIdAttribute}='${auxId}'] button svg {
      fill: ${vars.colors.primary.text} !important;
    }

    /* Hide the standard Service NSW logo row; the agency logo is rendered by
       AgencyLogoBar below the aux bar instead.
       @snsw/react-global-nav 4.1.0 has a hide logo prop we can switch to when global nav is upgraded
     */
    div[${headerIdAttribute}='${navId}'] {
      display: none !important;
    }`}
`;

export const AgencyLogoBar = styled.div`
  display: flex;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.75rem 1.5rem;
`;

export const AgencyLogo = styled.img`
  height: ${AGENCY_LOGO_HEIGHT}px;
  width: auto;
  display: block;
`;
